var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaviconIndorRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: "32px",
    height: "32px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3200 3200",
    m_init: 2270459202510131700,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BF8F00",
    d: "M500 0l2200 0c275,0 500,225 500,500l0 1600c0,275 -225,500 -500,500l-100 0 0 600 -600 -600 -1500 0c-275,0 -500,-225 -500,-500l0 -1600c0,-275 225,-500 500,-500z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M649 1334c-65,15 -124,36 -174,60 79,82 168,141 277,176 -42,-61 -77,-142 -103,-236zm250 -33c-53,2 -104,7 -152,14 24,85 78,219 152,268l0 -282zm253 14c-49,-7 -100,-12 -153,-14l0 283c75,-49 129,-183 153,-269zm272 79c-51,-24 -109,-44 -174,-60 -26,94 -61,174 -103,236 109,-35 198,-93 278,-176zm-701 -176c56,-9 114,-15 175,-17l0 -201 -199 0c3,77 11,150 24,217zm-313 97c62,-32 134,-58 215,-77 -14,-74 -23,-153 -26,-237l-299 0c9,116 48,223 110,314zm862 -77c81,19 153,46 215,77 62,-91 101,-198 110,-314l-299 0c-3,83 -12,163 -26,237zm-274 -36c61,2 120,8 176,17 13,-67 21,-140 24,-217l-199 0 0 201zm251 -635c65,-16 124,-36 174,-60 -79,-82 -168,-141 -278,-176 42,62 77,142 103,236zm-251 33c53,-2 104,-7 153,-14 -24,-85 -78,-220 -153,-269l0 283zm-252 -14c49,7 99,12 152,14l0 -282c-75,49 -128,183 -152,268zm-272 -79c51,24 109,44 174,60 26,-94 61,-174 103,-236 -110,35 -198,94 -277,176zm151 157c-81,-19 -153,-46 -215,-77 -62,91 -101,198 -110,314l299 0c2,-83 12,-163 26,-237zm273 36c-61,-2 -119,-8 -175,-17 -13,67 -21,140 -24,217l199 0 0 -201zm276 -17c-56,9 -115,15 -176,17l0 201 199 0c-3,-77 -11,-150 -24,-217zm313 -97c-62,32 -134,58 -215,77 14,74 23,153 26,237l299 0c-9,-116 -48,-223 -110,-314zm-539 -386c414,0 750,336 750,750 0,414 -336,750 -750,750 -414,0 -750,-336 -750,-750 0,-414 336,-750 750,-750zm2050 1200l-1329 0c-22,35 -46,68 -73,100l202 0 -700 650 50 100 750 -750 300 0 750 750 50 -100 -700 -650 700 0 0 -100zm-997 700l-13 300 120 0 -13 -300 -94 0zm6 -112l82 0 -9 -186 -64 0 -9 186zm19 -419l-6 132 57 0 -7 -132 -44 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviconIndorRoad);
export default __webpack_public_path__ + "static/media/favicon_indor_road.58850ac939ca939f62eff35e593f16f9.svg";
export { ForwardRef as ReactComponent };